"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.readFile = void 0;
const readFile = (file) => {
    // Browser path: use FileReader when available.
    if (typeof FileReader !== 'undefined') {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onabort = () => {
                reject(new Error('Read aborted'));
            };
            reader.onerror = () => {
                reject(reader.error);
            };
            reader.readAsArrayBuffer(file);
        });
    }
    // Server (Node.js 18+) path: Blob/File both expose arrayBuffer().
    return file.arrayBuffer();
};
exports.readFile = readFile;
